import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";
import { Menu, Layout, Spin } from "antd";
import { baseurl } from "../lib/settings";
import logo from "../../assets/logos/rm-logo.png"
import { LoadingOutlined } from '@ant-design/icons';
import {
  AppstoreOutlined,
  BarChartOutlined,
  CloudOutlined,
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
  AppstoreTwoTone,
  VideoCameraOutlined,
  AimOutlined,
  FolderOutlined,
  SettingOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

const Sidebar = ({ collapsed }) => {
  const { Sider } = Layout;
  const [selectedLink, setSelectedLink] = useState("/voting/all");
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyLogo, setCompanyLogo] = useState(logo);
  const [isCompanyDetailsFetched, setIsCompanyDetailsFetched] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'fixed',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarColor: 'unset',
    display: 'flex',
    flexDirection: 'column',
  };

  const logoStyle = {
    height: 70,
    margin: '16px',
    background: '#000F15',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const location = useLocation();

  useEffect(() => {
    setSelectedLink(location.pathname);
    baseurl.get("v1/check_userpermissions/").then((resp) => {
      setPermissions(resp.data);
    }).catch((error) => {
    });
    if (!isCompanyDetailsFetched) {
      getCompanyDetails();
    }
  }, [location.pathname]);

  const getCompanyDetails = async () => {
    try {
      setLoading(true);
      const response = await baseurl.post("v2/ngoma/company_details/");
      const logoUrl = response.data.length > 0 ? response.data[0].logo : logo;
      setCompanyLogo(logoUrl);
      setLoading(false);
      setIsCompanyDetailsFetched(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const items = [
    {
      key: '/dashboard',
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: '/voting/all',
      icon: <VideoCameraOutlined />,
      label: <Link to="/voting/all">Votos</Link>,
    },
    {
      key: '/voting/category',
      icon: <BarChartOutlined />,
      label: <Link to="/voting/category">Filtros</Link>,
    },

    {
      key: '/musician/all',
      icon: <CloudOutlined />,
      label: <Link to="/musician/all">Músicos</Link>,
    },
    {
      key: '/voting/search/personalised',
      icon: < AimOutlined />,
      label: <Link to="/voting/search/personalised">Relatório geral</Link>,
    },
    {
      key: '/company/edicoes',
      icon: <FolderOutlined />,
      label: <Link to="/company/edicoes">Edições</Link>,
    },

    {
      key: 'admin',
      icon: <AppstoreOutlined />,
      label: "Administração",
      visible: permissions.length > 0 && (permissions[0].voting_administrator || permissions[0].system_administrator),
      children: [
        {
          key: '/admin/delegacoes',
          icon: <FolderOutlined />,
          label: <Link to="/admin/delegacoes">Delegações</Link>,
        },
        {
          key: '/admin/musician/create',
          icon: <TeamOutlined />,
          label: <Link to="/admin/musician/create">Registar Canções</Link>,
        },
        // {
        //   key: '/admin/musician/all',
        //   icon: <ShopOutlined />,
        //   label: <Link to="/admin/musician/all">Lista de Músicos Geral</Link>,
        // },
        {
          key: '/admin/musicians-by-edition',
          icon: <TeamOutlined />,
          label: <Link to="/admin/musicians-by-edition">Músicos por Edição</Link>,
        },
        {
          key: '/voting/search/personalised-admin',
          icon: < AimOutlined />,
          label: <Link to="/voting/search/personalised">Relatório geral</Link>,
        },
        {
          key: '/admin/usuarios',
          icon: <UserOutlined />,
          label: <Link to="/admin/usuarios">Usuários</Link>,
        },
        {
          key: '/admin/edicoes',
          icon: <SettingOutlined />,
          label: <Link to="/admin/edicoes">Gestão de Edições</Link>,
        },
        {
          key: '/admin/disponibilidade',
          icon: <SafetyCertificateOutlined />,
          label: <Link to="/admin/disponibilidade">Estado do Sistema</Link>,
        },
      ],
    },
    {
      key: 'finance',
      icon: <ShopOutlined />,
      label: "Finanças",
      visible: permissions.length > 0 && permissions[0].finance_administrator,
      children: [
        {
          key: '/admin/finance/reports',
          icon: <ShopOutlined />,
          label: <Link to="/admin/finance/reports">Relatórios</Link>,
        },
        {
          key: '/admin/finance/query/votings',
          icon: <ShopOutlined />,
          label: <Link to="/admin/finance/query/votings">Consultas</Link>,
        },
      ],
    },
    {
      key: 'finance-partner',
      icon: <ShopOutlined />,
      label: "Finanças (Parceiro)",
      visible: permissions.length > 0 && permissions[0].partner_administrator,
      children: [
        {
          key: '/admin/finance/reports-partner',
          icon: <ShopOutlined />,
          label: <Link to="/admin/finance/reports">Relatórios</Link>,
        },
      ],
    },
  ];

  const menuItems = items
    .filter(item => item.visible !== false)
    .map(item => {
      if (item.children) {
        return {
          key: item.key,
          icon: item.icon,
          label: item.label,
          children: item.children.map(child => ({
            key: child.key,
            icon: child.icon,
            label: child.label,
            disabled: child.disabled
          }))
        };
      }
      return {
        key: item.key,
        icon: item.icon,
        label: item.label,
        disabled: item.disabled
      };
    });

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={siderStyle}
      width={250}
    >
      <div style={logoStyle}>
        {loading ? (
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
          />
        ) : (
          <img src={companyLogo} alt="Logotipo" className="company-logo" />
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedLink]}
        onClick={(e) => setSelectedLink(e.key)}
        items={menuItems}
      />
      {user && user.last_login && (
        <div style={{ position: 'absolute', bottom: 10, left: 0, right: 0, textAlign: 'center', color: 'rgba(255, 255, 255, 0.45)', fontSize: '11px', padding: '0 10px', opacity: collapsed ? 0 : 1, transition: 'opacity 0.3s' }}>
          Último login:<br />{new Date(user.last_login).toLocaleString('pt-PT')}
        </div>
      )}
    </Sider>
  );
};

export default Sidebar;
